const LangCode = {
  'English': 'en',
  'Finnish': 'fi'
};
Object.freeze(LangCode);

export default LangCode;
